// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1npDW","text":"SelectPayment_text__1v_yz","title":"SelectPayment_title__2CLpe","btn":"SelectPayment_btn__1__BH"};